import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SharedModule } from '@app-shared/shared.module';
import { SHARED_COMPONENTS } from './components';
import { AuthStoreModule } from '../user/user-auth.module';

@NgModule({
	imports: [
		CommonModule,
		// SharedModule,
		AuthStoreModule,
	],
	declarations: [...SHARED_COMPONENTS],
	exports: [...SHARED_COMPONENTS],
})
export class ProfileSharedModule {}
